import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createEntityDocument } from './documents.service'

export const useEntityDocumentCreate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createEntityDocument,
    onSuccess: async (_, vars) => {
      await queryClient.invalidateQueries({
        queryKey: ['entityDocuments', vars.entityId],
      })
    },
  })
}
